import React from 'react';

import { useDataState } from '../../../providers/DataProvider.hooks';
import { TopCathletes } from '../../common/TopCathletes/TopCathletes';

export const TopMewllionaires = () => {
    const { cathletes, top10Cathletes } = useDataState();

    return (
        <TopCathletes
            mode="topServer"
            top10Cathletes={top10Cathletes}
            headerText="TOP Mewllionaires of the season"
            subHeaderText="The last update of the CAThletes data was"
            lastModified={cathletes?.last_modified}
        ></TopCathletes>
    );
};
